/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingtypepost2Inputs */

const en_crosspostingtypepost2 = /** @type {(inputs: Crosspostingtypepost2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post`)
};

const de_crosspostingtypepost2 = /** @type {(inputs: Crosspostingtypepost2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beitrag`)
};

/**
* | output |
* | --- |
* | "Post" |
*
* @param {Crosspostingtypepost2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingtypepost2 = /** @type {((inputs?: Crosspostingtypepost2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingtypepost2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingtypepost2(inputs)
	return de_crosspostingtypepost2(inputs)
});
export { crosspostingtypepost2 as "crosspostingTypePost" }